import * as reduxApi from 'src/utils/redux-api-v2';
import logger from 'src/utils/logger';
import type {Dispatch} from 'src/reducers';


export const sendNotificationTokenToServer = async (
  dispatch: Dispatch,
  fcmToken: string,
) => {
  if (!dispatch) {
    logger.error('Redux dispatch unavailable for FCM token registration');
    return;
  }

  try {
    await dispatch(
      reduxApi.post('messaging-service/push-notification/registration/', {
        device_type: 'chrome',
        address: fcmToken,
      }),
    );
  } catch (error: any) {
    logger.error(error);
  }
};

export const deleteNotificationTokenFromServer = async (
  dispatch: Dispatch,
  fcmToken: string,
) => {
  if (!fcmToken) {
    return;
  }
  if (!dispatch) {
    logger.error('Redux dispatch unavailable for FCM token deletion');
    return;
  }

  try {
    await dispatch(
      reduxApi.del(
        `messaging-service/push-notification/registration/chrome/${fcmToken}`,
      ),
    );
  } catch (error: any) {
    logger.error(error);
  }
};
